import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import {
    FormsModule,
    ReactiveFormsModule,
    UntypedFormControl,
    UntypedFormGroup,
    ValidatorFn
} from "@angular/forms";
import { InputComponent } from "@components/input/input.component";
import { PageComponent } from "@components/page/page.component";
import { SubmitButtonComponent } from "@components/submit-button/submit-button.component";
import { BusyService } from "~app/common/components/busy/busy.service";
import { AnvandareListRequestDTO } from "~app/common/models/anvandare/AnvandareListRequestDTO";
import { AnvandareListResponseDTO } from "~app/common/models/anvandare/AnvandareListResponseDTO";
import { ValidationMessageRowComponent } from "~app/common/validation/validation-message-row/validation-message-row.component";
import { AnvandareEditService } from "./anvandare-edit.service";
import { AnvandareListComponent } from "./anvandare-list/anvandare-list.component";

const atLeastOneRequired: ValidatorFn = (control) => {
    for (const value of Object.values(control.value)) {
        if (value) {
            return null;
        }
    }
    return { atLeastOneRequired: true };
};

@Component({
    selector: "rask-anvandare",
    templateUrl: "./anvandare.component.html",
    styleUrls: ["./anvandare.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        PageComponent,
        FormsModule,
        ReactiveFormsModule,
        InputComponent,
        SubmitButtonComponent,
        AnvandareListComponent,
        ValidationMessageRowComponent
    ]
})
export class AnvandareComponent {
    protected anvandare: AnvandareListResponseDTO[];
    protected searchForm = new UntypedFormGroup({
        firstname: new UntypedFormControl(""),
        lastname: new UntypedFormControl(""),
        userid: new UntypedFormControl(""),
        mail: new UntypedFormControl("")
    }, [atLeastOneRequired]);

    private readonly anvandareEditService = inject(AnvandareEditService);
    private readonly busyService = inject(BusyService);

    search() {
        this.searchForm.markAllAsTouched();
        if (this.searchForm.invalid) {
            return;
        }

        const param = {
            firstName: this.searchForm.get("firstname").value,
            lastName: this.searchForm.get("lastname").value,
            userName: this.searchForm.get("userid").value,
            mail: this.searchForm.get("mail").value
        } as AnvandareListRequestDTO;

        this.busyService.addWork(this.anvandareEditService.searchForAnvandare(param)).subscribe(result => {
            this.anvandare = result;
        });
    }
}
